import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import qs from 'qs';

import { links } from '../../../constants/general';
import { serializeToQueryString } from '../../../helpers/general';
import { getSavedAuthToken } from '../../../api/httpClient';

export const pageTabs = {
  applicants: {
    id: 'applicants',
    ui: 'Applicants'
  },
  candidates: {
    id: 'candidates',
    ui: 'Candidates'
  }
};

class Applicants extends PureComponent {
  static propTypes = {
    user: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    const { selectedTab } = query;

    this.state = {
      selectedTab: selectedTab || pageTabs.applicants.id,
    }
  }

  switchTab = event => {
    this.setState({ selectedTab: event.target.id }, this._loadData);
    this.forceUpdate();
  }

  renderTabContent = () => {
    const { selectedTab } = this.state;
    const { userid } = this.props.user;
    const token = getSavedAuthToken();
    const params = {
      src: 'ghost',
      iframe: 'true',
      user_id: userid,
      token: token,
      timestamp: new Date().getTime()
    };
    const queryString = serializeToQueryString(params);

    switch (selectedTab) {
      case pageTabs.applicants.id:
        return (
          <div className='iframe-wrappper'>
            <iframe
              className='applicants-iframe'
              src={`${links.applicants}?${queryString}`}
              title='applicants-iframe'
            />
          </div>
        )
      default:
        return (
          <div className='iframe-wrappper'>
            <iframe
              className='candidates-iframe'
              src={`${links.candidates}?${queryString}`}
              title='candidates-iframe'
            />
          </div>
        )
    }
  }

  render () {
    const { selectedTab } = this.state;

    return (
      <div>
        <div className='tabs-wrapper'>
          <button
            id={pageTabs.applicants.id}
            className={selectedTab === pageTabs.applicants.id ? 'tab active' : 'tab'}
            onClick={this.switchTab}
          >{pageTabs.applicants.ui}</button>
          <button
            id={pageTabs.candidates.id}
            className={selectedTab === pageTabs.candidates.id ? 'tab active' : 'tab'}
            onClick={this.switchTab}
          >{pageTabs.candidates.ui}</button>
        </div>

        {this.renderTabContent()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps, null)(Applicants);



// WEBPACK FOOTER //
// ./src/components/app/applicants/index.js